import {Button, Col, Container, Row} from "reactstrap";
import React from "react";
import Image from "next/image";
import Link from "next/link"
import withApollo from "../lib/withApollo";
import {getDataFromTree} from "@apollo/react-ssr";
import {useQuery} from "@apollo/client";
import PROMOTION_BLOCK from "../graphql/queries/promotionBlock";

const ActionBlock = () => {
    const {loading, error, data, client} = useQuery(PROMOTION_BLOCK);

    if (loading) {
        return <span></span>;
    }

    if (!data.PromotionBlock.hasPromotion) {
        return <span></span>;
    }

    return (
        <section className='py-2'>
            <Container fluid>
                <Row className="">
                    <Col xl="10" lg="10" className="mx-auto">
                        <Row className="mb-5">
                            <Col md="8">
                                <h2 className="h2 action-text text-orange">
                                    <i className="fas fa-percent mr-1"/> Aanbieding
                                </h2>
                                <h3 className="h4">{data.PromotionBlock.promotion.title}</h3>
                                <p>
                                    {data.PromotionBlock.promotion.text}
                                </p>
                                <p className="text-align-center">
                                    <Link
                                        prefetch={false}
                                        href={data.PromotionBlock.promotion.link}
                                    >
                                        <Button size="lg" color="primary" className="my-4">
                                            {data.PromotionBlock.promotion.linkText}
                                        </Button>
                                    </Link>
                                </p>
                            </Col>
                            <Col md="4">
                                <Link
                                    passHref
                                    prefetch={false}
                                    href={data.PromotionBlock.promotion.link}
                                >
                                    <a>
                                        <Image
                                            src={data.PromotionBlock.promotion.image}
                                            layout="responsive"
                                            width="300px"
                                            height="200px"
                                        />
                                    </a>
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default withApollo(ActionBlock, {getDataFromTree});
